import { render, staticRenderFns } from "./ReviewsModule.vue?vue&type=template&id=a9ba9f84"
import script from "./ReviewsModule.vue?vue&type=script&lang=js"
export * from "./ReviewsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports